<div class="B2BBodyHalf">

  <div class="SectionTitle unSelectable" (click)="this.ShowMyData = !this.ShowMyData;">
    <span>{{'MyData' | translate}}</span>
    <i class="material-icons" *ngIf="!this.ShowMyData">keyboard_arrow_right</i>
    <i class="material-icons" *ngIf="this.ShowMyData">keyboard_arrow_down</i>
  </div>

  <div *ngIf="this.ShowMyData">
    <div class="TextBoxTitle">{{'Email' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input style="cursor: not-allowed;" disabled="true" type="text" class="TextBoxContainer"
        placeholder="{{'Email' | translate}}" [(ngModel)]="this.parent.User.Email" matInput>
      <i class="material-icons">email</i>
    </div>

    <div class="APISection" *ngIf="this.parent.User?.B2BSettings?.B2BSearchPriceAPIAccess == true;">

      <div class="APISectionTitle">
        {{'YourAPICredentials' | translate}}
      </div>

      <div class="TextBoxTitle">{{'APIKey' | translate}}</div>
      <div class="CentralTextBoxContainer" style="height: 100px;">
        <textarea class="TextBoxContainer" [disabled]="true" placeholder="{{'APIKey' | translate}}"
          [(ngModel)]="this.parent.User.Id" rows="3" style="resize: none; cursor: not-allowed; height: 92.5px;" matInput>
        </textarea>
        <i class="material-icons">key</i>
      </div>

      <div class="TextBoxTitle">{{'SecretToken' | translate}}</div>
      <div class="CentralTextBoxContainer" style="height: 100px;">
        <textarea class="TextBoxContainer" [disabled]="true" placeholder="{{'SecretToken' | translate}}"
          [(ngModel)]="this.B2BPartner.ID" rows="3" style="resize: none; cursor: not-allowed; height: 92.5px;" matInput>
        </textarea>
        <i class="material-icons">key</i>
      </div>

      <p class="APIAccessRow" matTooltip="{{'B2BSearchPriceAPIAccessDescription' | translate}}" matTooltipClass='neutral-tool-tip' *ngIf="this.parent.User?.B2BSettings?.B2BSearchPriceAPIAccess == true;">
        <i class="material-icons">verified</i>
        <span>{{'YouHaveAPIAccessFor' | translate}}: {{'B2BSearchPriceAPIAccess' | translate}}</span>
      </p>

    </div>

    <div class="TextBoxTitle">{{'Name' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input type="text" class="TextBoxContainer" placeholder="{{'Name' | translate}}"
        [(ngModel)]="this.parent.User.UIName" matInput>
      <i class="material-icons">account_circle</i>
    </div>

    <div class="TextBoxTitle">{{'Login.Phone' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input type="text" class="TextBoxContainer" placeholder="{{'Login.Phone' | translate}}"
        [(ngModel)]="this.parent.User.Phone" matInput>
      <i class="material-icons">smartphone</i>
    </div>

    <div class="WidgetContainer">
      <mat-form-field class="UserCompanyRolesSelect" appearance="outline">
        <mat-label>{{ 'AccountSettingsPage.DefaultLanguage' | translate }}</mat-label>
        <mat-select name="Language" [compareWith]="parent.compareFn" [(ngModel)]="this.parent.User.Settings.Language">
          <mat-option *ngFor="let lang of this.parent.masterData?.Languages; index as i" [value]="lang"
            (click)="this.parent.ChangeLanguage(lang);">
            {{lang.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="WidgetContainer">
      <mat-form-field class="UserCompanyRolesSelect" appearance="outline"
        matTooltip="{{'B2BCurrencyChangeRequest' | translate}}" matTooltipClass='neutral-tool-tip'>
        <mat-label>{{ 'Currency' | translate }}</mat-label>
        <mat-select name="Currencies" [compareWith]="parent.compareFn" [(ngModel)]="this.parent.User.B2BSettings.PrefferedCurrency">
          <mat-option *ngFor="let c of this.Currencies; index as i" [value]="c" (click)="this.UpdateUser();">
            {{c.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="TextBoxTitle">{{'ConfirmationEmail' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input type="text" class="TextBoxContainer" placeholder="{{'ConfirmationEmail' | translate}}"
        [(ngModel)]="this.parent.User.B2BSettings.ConfirmationEmail" matInput>
      <i class="material-icons">email</i>
    </div>

    <div class="WidgetContainer">
      <button mat-raised-button color="primary" (click)="UpdateUser();">
        {{ 'AccountSettingsPage.UpdateMyDetailsButton' | translate }}
      </button>
    </div>

    <div class="SectionTitle">
      {{ 'AccountSettingsPage.Security' | translate }}
    </div>

    <div class="WidgetContainer">
      <mat-form-field class="fullWidth">
        <input matInput placeholder="{{ 'AccountSettingsPage.OldPassword' | translate }}"
          [type]="hide ? 'password' : 'text'" [(ngModel)]="this.Password" required>
        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </mat-form-field>
    </div>

    <div class="WidgetContainer">
      <mat-form-field class="fullWidth">
        <input matInput placeholder="{{ 'AccountSettingsPage.NewPassword' | translate }}"
          [type]="hide ? 'password' : 'text'" [(ngModel)]="this.NewPassword" required>
        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </mat-form-field>
    </div>

    <div class="WidgetContainer">
      <mat-form-field class="fullWidth">
        <input matInput placeholder="{{ 'AccountSettingsPage.ConfirmNewPassword' | translate }}"
          [type]="hide ? 'password' : 'text'" [(ngModel)]="this.ConfirmNewPassword" required>
        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </mat-form-field>
    </div>

    <div class="WidgetContainer" style="margin-bottom: 2%;">
      <button mat-raised-button color="primary" (click)="ChangeUserPassword();">{{ 'AccountSettingsPage.ChangePassword'
        | translate }}</button>
    </div>
  </div>

</div>

<div class="B2BBodyHalf">
  <div class="SectionTitle unSelectable" (click)="this.ShowBilling = !this.ShowBilling;">
    <span>{{'CompanyData' | translate}} {{'BillingInformation' | translate}}</span>
    <i class="material-icons" *ngIf="!this.ShowBilling">keyboard_arrow_right</i>
    <i class="material-icons" *ngIf="this.ShowBilling">keyboard_arrow_down</i>
  </div>

  <div *ngIf="this.ShowBilling">
    <div class="TextBoxTitle">{{'Name' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input style="cursor: not-allowed;" disabled="true" type="text" class="TextBoxContainer"
        placeholder="{{'Name' | translate}}" [(ngModel)]="this.B2BPartner.Name" matInput>
      <i class="material-icons">verified</i>
    </div>

    <div class="TextBoxTitle">{{'VAT' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input style="cursor: not-allowed;" disabled="true" type="text" class="TextBoxContainer"
        placeholder="{{'VAT' | translate}}" [(ngModel)]="this.B2BPartner.VAT" matInput>
      <i class="material-icons" *ngIf="this.B2BPartner.EUVATVerified == true;" style="color: #32aa3a;">verified_user</i>
      <i class="material-icons" *ngIf="this.B2BPartner.EUVATVerified != true;" style="color: red;">warning_amber</i>
    </div>

    <div class="TextBoxTitle">{{'COCRegNumber' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input style="cursor: not-allowed;" disabled="true" type="text" class="TextBoxContainer"
        placeholder="{{'COCRegNumber' | translate}}" [(ngModel)]="this.B2BPartner.COCRegNumber" matInput>
    </div>

    <div class="TextBoxTitle">{{'Country' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input style="cursor: not-allowed;" disabled="true" type="text" class="TextBoxContainer"
        placeholder="{{'Country' | translate}}" [(ngModel)]="this.B2BPartner.BillingAddress.Country.Name" matInput>
    </div>

    <div class="TextBoxTitle">{{'StateProvince' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input style="cursor: not-allowed;" disabled="true" type="text" class="TextBoxContainer"
        placeholder="{{'StateProvince' | translate}}" [(ngModel)]="this.B2BPartner.BillingAddress.StateProvince"
        matInput>
    </div>

    <div class="TextBoxTitle">{{'City' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input style="cursor: not-allowed;" disabled="true" type="text" class="TextBoxContainer"
        placeholder="{{'City' | translate}}" [(ngModel)]="this.B2BPartner.BillingAddress.City" matInput>
    </div>

    <div class="TextBoxTitle">{{'AddressLine' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input style="cursor: not-allowed;" disabled="true" type="text" class="TextBoxContainer"
        placeholder="{{'AddressLine' | translate}}" [(ngModel)]="this.B2BPartner.BillingAddress.AddressLine" matInput>
    </div>

    <div class="TextBoxTitle">{{'ZipCode' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input style="cursor: not-allowed;" disabled="true" type="text" class="TextBoxContainer"
        placeholder="{{'ZipCode' | translate}}" [(ngModel)]="this.B2BPartner.BillingAddress.ZipCode" matInput>
    </div>

    <div class="TextBoxTitle">{{'Email' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input style="cursor: not-allowed;" disabled="true" type="text" class="TextBoxContainer"
        placeholder="{{'Email' | translate}}" [(ngModel)]="this.B2BPartner.ContactInfo.Email" matInput>
    </div>

    <div class="TextBoxTitle">{{'Name' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input style="cursor: not-allowed;" disabled="true" type="text" class="TextBoxContainer"
        placeholder="{{'Name' | translate}}" [(ngModel)]="this.B2BPartner.ContactInfo.Name" matInput>
    </div>

    <div class="TextBoxTitle">{{'Phone' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input style="cursor: not-allowed;" disabled="true" type="text" class="TextBoxContainer"
        placeholder="{{'Phone' | translate}}" [(ngModel)]="this.B2BPartner.ContactInfo.Phone" matInput>
    </div>
  </div>

</div>

<div class="B2BBodyHalf">
  <div class="SectionTitle unSelectable" (click)="GetShippingAddresses();">
    <span>{{'ShippingAddresses' | translate}}</span>
    <i class="material-icons" *ngIf="!this.ShowShipping">keyboard_arrow_right</i>
    <i class="material-icons" *ngIf="this.ShowShipping">keyboard_arrow_down</i>
  </div>

  <div *ngIf="this.ShowShipping && this.CurrentShippingAddress != null;">

    <div class="fullWidth" style="float:left;">
      <mat-spinner *ngIf="this.LoadShippingAddresses == true;" class="ShippingAddressesSpinner"
        [diameter]="30"></mat-spinner>
    </div>

    <div class="fullWidth" style="float:left;">
      <mat-form-field appearance="outline" class="ProductPropertyTextBox"
        *ngIf="this.B2BPartner.ShippingAddresses?.length > 0 && this.LoadShippingAddresses != true;">
        <mat-label>{{ 'ShippingAddresses' | translate }}</mat-label>
        <mat-select name="ShippingAddresses" [compareWith]="this.parent.compareFn"
          [(ngModel)]="this.CurrentShippingAddress" style="height: 30px;padding-top: 7px;">
          <mat-option *ngFor="let a of this.B2BPartner.ShippingAddresses" [value]="a"
            (click)="FindCurrentChangeRequest();">
            {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="ProductPropertyTextBox">
      <mat-label>{{ 'Country' | translate }}</mat-label>
      <mat-select name="ShippingAddresses" [compareWith]="this.parent.compareFn"
        [(ngModel)]="this.CurrentShippingAddress.Country" style="height: 30px;padding-top: 7px;">
        <mat-option *ngFor="let c of this.parent.masterData.Countries" [value]="c">
          {{c.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="TextBoxTitle">{{'StateProvince' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input type="text" class="TextBoxContainer" placeholder="{{'StateProvince' | translate}}"
        [(ngModel)]="this.CurrentShippingAddress.State" matInput>
    </div>

    <div class="TextBoxTitle">{{'Partners.PartnerWindow.City' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input type="text" class="TextBoxContainer" placeholder="{{'Partners.PartnerWindow.City' | translate}}"
        [(ngModel)]="this.CurrentShippingAddress.City" matInput>
    </div>

    <div class="TextBoxTitle">{{'Partners.PartnerWindow.AddressLine' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input type="text" class="TextBoxContainer" placeholder="{{'Partners.PartnerWindow.AddressLine' | translate}}"
        [(ngModel)]="this.CurrentShippingAddress.AddressLine" matInput>
    </div>

    <div class="TextBoxTitle">{{'ZipCode' | translate}}</div>
    <div class="CentralTextBoxContainer">
      <input style="letter-spacing: 2px;font-weight: 500;" type="text" class="TextBoxContainer"
        placeholder="{{'ZipCode' | translate}}" [(ngModel)]="this.CurrentShippingAddress.ZipCode" matInput>
    </div>

    <div class="ToggleContainer" style="margin-bottom: 20px;">
      <mat-slide-toggle [(ngModel)]="this.CurrentShippingAddress.ActiveAddress">
        <span *ngIf="this.CurrentShippingAddress.ActiveAddress == true;">{{'ActiveAddress' | translate}}</span>
        <span *ngIf="this.CurrentShippingAddress.ActiveAddress != true;">{{'DisabledAddress' | translate}}</span>
      </mat-slide-toggle>
    </div>

    <div class="ToggleContainer">
      <mat-slide-toggle [(ngModel)]="this.CurrentShippingAddress.IsSelected">{{'MainAddress' |
        translate}}</mat-slide-toggle>
    </div>

    <button *ngIf="this.CurrentShippingAddress?.ID != null;" mat-raised-button color="primary"
      class="RequestAddressChangeButton" (click)="AddPartnerShippingAddressChangeRequest(this.CurrentShippingAddress);">
      <span>{{'RequestAddressChange' | translate}}</span>
      <i class="material-icons">change_circle</i>
    </button>

    <div class="ChangeRequestInfo" *ngIf="CurrentShippingAddressChangeRequest?.ID > 0;">
      <i class="material-icons unSelectable" *ngIf="CurrentShippingAddressChangeRequest.Applied != true;">info</i>
      <i class="material-icons unSelectable" *ngIf="CurrentShippingAddressChangeRequest.Applied == true;"
        style="color: #32aa3a;">verified</i>
      <p>{{CurrentShippingAddressChangeRequest.RegisteredUI}}</p>
      <p *ngIf="CurrentShippingAddressChangeRequest.Applied != true;">{{'CurrentShippingAddressChangeRequest' |
        translate}}</p>
      <p *ngIf="CurrentShippingAddressChangeRequest.Applied == true;">{{'CurrentShippingAddressChangeRequestApplied' |
        translate}}</p>
    </div>

  </div>

  <div *ngIf="this.ShowShipping && this.CurrentShippingAddress == null;">
    <button mat-raised-button color="primary" class="AddNewAddressButton">
      <i class="material-icons">add</i>
      <span>{{ 'AddNewAddress' | translate }}</span>
    </button>
  </div>
</div>

<div style="height: 50px;width: 100%;float: left;"></div>